// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"2df37486","614":"b2e63584"}[chunkId] + ".chunk.js";
};